<mat-toolbar color="primary" class="toolbar">
  <button
    type="button"
    aria-label="Toggle sidenav"
    mat-icon-button
    (click)="store.toggleSidenav()"
  >
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <div class="logo"></div>
  <span class="spacer"></span>
  <span class="date-time">{{ store.formattedTime() }}</span>
  <div class="avatar-container">
    <app-avatar
      [userName]="authStore.currentUser()!.fullName"
      [size]="'small'"
      cdkOverlayOrigin
      #origin="cdkOverlayOrigin"
      (click)="toggleUserProfile()"
      class="avatar-button"
    ></app-avatar>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOpen]="store.showUserProfile()"
      [cdkConnectedOverlayHasBackdrop]="true"
      (overlayOutsideClick)="toggleUserProfile()"
      [cdkConnectedOverlayPanelClass]="'profile-overlay'"
      [cdkConnectedOverlayDisableClose]="false"
      [cdkConnectedOverlayScrollStrategy]="overlay.scrollStrategies.block()"
    >
      <app-user-profile #userProfile></app-user-profile>
    </ng-template>
  </div>
</mat-toolbar>
